import Socket from '../connection/socket';
import Invitations from './invitations';
import { getState, socketListenerDispatch } from './socket-listener-main';
import * as HomeActions from '../stores/actions/home';

function refreshNotifications() {
	const { SessionReducer: { token } } = getState();

	socketListenerDispatch(HomeActions.loadNotifications(token));
}

export default function TempSocketListeners(socket: Socket) {
	Invitations(socket);

	const { SessionReducer: { embed } } = getState();

	if (!embed) {
		socket.addListener('notification-refresh', refreshNotifications);
	}
}